import { useMemo } from "react";
import { useParams, useHistory } from "react-router-dom";

// 在以下路径页面，会去更新url path id
const PATH_EFFECTIVE = ["/app/mortgagegpt", "/guidelinegpt"];

/**
 * @name useSyncUrlPathID AI问答中，可将threadId添加至url path中
 */
export default function useSyncUrlPathID() {
  const history = useHistory();
  const { threadID } = useParams();

  const pathname = history.location?.pathname;

  const PATH_CURRENT = useMemo(
    () =>
      PATH_EFFECTIVE.find(
        (path) => pathname.startsWith(path + "/") || pathname === path,
      ),
    [pathname],
  );

  const IS_PATH_CONFIG_ENABLED = PATH_EFFECTIVE.includes(PATH_CURRENT)

  /**
   * @name onRoutePath 更新当前问答id状态到url path
   * @param {string | undefined} threadId 问答id
   * @description 必须登陆才会写入 (IS_IFRAMES除外)
   */
  function onRoutePathReplace(threadId: string) {
    if (IS_PATH_CONFIG_ENABLED && sessionStorage.getItem('ZeitroA')) {
      history.replace(`${PATH_CURRENT}${threadId ? `/${threadId}` : ""}`);
    }
  }

  return {
    threadID,
    onRoutePathReplace,
    /**
     * @param IS_PATH_CONFIG_ENABLED 是否配置生效
     * @description 只有在指定（URL）页面路径会为true
     */
    IS_PATH_CONFIG_ENABLED,
  };
}
